export enum TableMode {
    Open,
    Close,
    InternalTest,
    Pause,
    InternalTestPause,
}
